<script setup lang="ts">
import { computed } from 'vue';

import { GrammarBadge, GrammarSwitch } from '@nora-monorepo/grammar-ui';

import { useMapStore } from '#nora-ui/map/stores/map-store';

interface ToggleClusterProps {
  mapId: string;
}

const props = defineProps<ToggleClusterProps>();

const mapStore = useMapStore();

const map = mapStore.getMapByIdOrThrow(props.mapId);

const isClusterEnabled = computed(() => {
  return map.layers.isEveryLayerClustered();
});

function toggleClustering() {
  map.layers.setClusterMode(!isClusterEnabled.value);
}
</script>

<template>
  <div class="flex justify-between">
    <div class="flex items-center">
      <GrammarBadge
        label="Clustering"
        :emphasis="isClusterEnabled ? 'no-background-high' : 'no-background'"
      />
    </div>
    <div>
      <GrammarSwitch
        :selected="isClusterEnabled"
        @change="toggleClustering()"
      />
    </div>
  </div>
</template>
